
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("1beTy", function(module, exports) {
$parcel$export(module.exports, "PermissionErrorView", () => $ae53695dd23ce85c$export$1bd3db7a0a8884d3);
$parcel$export(module.exports, "default", () => $ae53695dd23ce85c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aMums = parcelRequire("aMums");

var $9wMmq = parcelRequire("9wMmq");
var $6OND9 = parcelRequire("6OND9");

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");

var $Y6IEf = parcelRequire("Y6IEf");

var $lRq8t = parcelRequire("lRq8t");

var $9fUwN = parcelRequire("9fUwN");

var $jlGqM = parcelRequire("jlGqM");
const $ae53695dd23ce85c$var$ErrorImage = ()=>(0, $7jTnu.fg)('replace_error_display_with_empty_state') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9wMmq.default), {
        xcss: $ae53695dd23ce85c$var$imageWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Y6IEf.default), {
        width: 90,
        height: 130,
        alt: ""
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Y6IEf.default), {
        width: 90,
        height: 130,
        alt: ""
    });
const $ae53695dd23ce85c$export$1bd3db7a0a8884d3 = ()=>{
    const permissionErrorDescriptionGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $jlGqM.messages).permissionErrorDescriptionGalaxia : (0, $jlGqM.messages).permissionErrorDescription;
    const intl = (0, $lRq8t.default)();
    return (0, $7jTnu.fg)('replace_error_display_with_empty_state') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aMums.default), {
        testId: "issue-view-errors.ui.permission-error-view.permission-error-view",
        header: intl.formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $jlGqM.messages).permissionErrorHeaderIssueTermRefresh : (0, $jlGqM.messages).permissionErrorHeader),
        description: intl.formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $jlGqM.messages).permissionErrorDescriptionIssueTermRefresh : permissionErrorDescriptionGalaxia),
        renderImage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ae53695dd23ce85c$var$ErrorImage, null)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9fUwN.ErrorDisplay), {
        header: intl.formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $jlGqM.messages).permissionErrorHeaderIssueTermRefresh : (0, $jlGqM.messages).permissionErrorHeader),
        description: intl.formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $jlGqM.messages).permissionErrorDescriptionIssueTermRefresh : permissionErrorDescriptionGalaxia),
        image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ae53695dd23ce85c$var$ErrorImage, null)
    });
};
const $ae53695dd23ce85c$var$imageWrapperStyles = (0, $6OND9.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});
var $ae53695dd23ce85c$export$2e2bcd8739ae039 = $ae53695dd23ce85c$export$1bd3db7a0a8884d3;

});
parcelRegister("Y6IEf", function(module, exports) {
$parcel$export(module.exports, "default", () => $83769ae1d2aa43d1$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = mmwr66tqxzps49fhmn4694w
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/mmwr66tqxzps49fhmn4694w

var $c4huj = parcelRequire("c4huj");

var $3UGVR = parcelRequire("3UGVR");

var $2giXe = parcelRequire("2giXe");
const $83769ae1d2aa43d1$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($2giXe)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($3UGVR))
});
var $83769ae1d2aa43d1$export$2e2bcd8739ae039 = $83769ae1d2aa43d1$var$Illustration;
// for advanced use only
const $83769ae1d2aa43d1$export$a179c88182cb9d56 = [
    0,
    0,
    191,
    222
];

});
parcelRegister("3UGVR", function(module, exports) {
module.exports = new URL("lock-closed-darkmode.26d51607.svg", import.meta.url).toString();

});

parcelRegister("2giXe", function(module, exports) {
module.exports = new URL("lock-closed.22dbfd6e.svg", import.meta.url).toString();

});


parcelRegister("jlGqM", function(module, exports) {
$parcel$export(module.exports, "messages", () => $8f101e245a9d9377$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $8f101e245a9d9377$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    permissionErrorHeader: {
        "id": "issue-view-errors.permission-error-view.permission-error-header",
        "defaultMessage": "You don't have access to this issue"
    },
    permissionErrorDescription: {
        "id": "issue-view-errors.permission-error-view.permission-error-description",
        "defaultMessage": "Make sure the issue exists in this project. If it does, ask a project admin for permission to see the project's issues."
    },
    permissionErrorHeaderIssueTermRefresh: {
        "id": "issue-view-errors.permission-error-view.permission-error-header-issue-term-refresh",
        "defaultMessage": "You don't have access to this work item"
    },
    permissionErrorDescriptionIssueTermRefresh: {
        "id": "issue-view-errors.permission-error-view.permission-error-description-issue-term-refresh",
        "defaultMessage": "Make sure the work item exists in this project. If it does, ask a project admin for permission to see work in this project."
    },
    permissionErrorDescriptionGalaxia: {
        "id": "issue-view-errors.permission-error-view.permission-error-description-galaxia",
        "defaultMessage": "Make sure the work item exists in this space. If it does, ask an admin for permission to see work in this space."
    }
});

});



$parcel$global.rlb("10R7y")
//# sourceMappingURL=permission-error-view.3092b13f.js.map
